import { osName } from "react-device-detect"
import { androidAppLink, iosAppLink } from "../constant"

export const handleDownloadLinkAndroid = () => {
    return androidAppLink
}
export const handleDownloadLinkIos = () => {
    return iosAppLink
}
